/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */

import React from 'react';
import { Link } from 'react-router-dom';
import Discuss from 'parts/Discuss';

import Industries from 'data/industries';
import { Fade } from "react-awesome-reveal";
import slugify from '../../utils/slugify';

export default function IndustriesPage() {
  return (
    <>
      <section className="py-20 lg:py-28 bg-premium-light">
        <div className="container mx-auto px-6">

          <Fade direction="up" triggerOnce>
            <div className="text-center mb-4">
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-green-50 text-brand-green-600 text-sm font-semibold tracking-wide uppercase mb-4">
                Who We Serve
              </span>
            </div>
            <h1 className="text-4xl lg:text-5xl font-extrabold text-surface-900 mb-6 text-center tracking-tight">Industries We Serve</h1>
          </Fade>

          <Fade delay={100} direction="up" triggerOnce>
            <p className="text-surface-300 text-lg mb-16 max-w-2xl mx-auto text-center">
              Explore the industries we support with tailored IT solutions designed for growth, security, and performance.
            </p>
          </Fade>

          {/* GRID OF SYMMETRIC CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {Industries.map((industry, index) => {
              const slug = slugify(industry);

              // Use exact filenames for specific cases, else fallback to standard slug jpg
              let imgFilename = `${slug}.jpg`;
              if (slug === 'manufacturing-and-logistics') {
                // Check the listed files, M&L has both .jpg and .png, we'll try .png and .jpg
                imgFilename = 'manufacturing-and-logistics.jpg';
              }
              if (industry === 'Aviation') {
                imgFilename = 'Aviation.jpg'; // capitalized
              }

              return (
                <Fade key={industry} direction="up" delay={100 * (index + 1)} triggerOnce>
                  <Link to={`/industries/${slug}`} className="block group h-full">

                    <div className="glass-card flex flex-col overflow-hidden h-[100%] min-h-[380px]">

                      {/* Image section */}
                      <div className="w-full h-48 relative overflow-hidden flex-shrink-0">
                        <img src={`/hero/industries/${imgFilename}`} alt={industry} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                      </div>

                      <div className="p-6 flex flex-col flex-1">
                        {/* Title */}
                        <h2 className="text-xl font-bold text-surface-900 mb-3">
                          {industry}
                        </h2>

                        {/* Description */}
                        <p className="text-surface-300 text-sm flex-1 leading-relaxed">
                          IT services specialized for the {industry.toLowerCase()} sector. Learn how we can help you grow and stay secure.
                        </p>

                        {/* Footer */}
                        <span className="mt-4 text-brand-green-500 font-semibold text-sm flex items-center gap-1 group-hover:gap-2 transition-all">
                          Learn more
                          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </span>
                      </div>

                    </div>

                  </Link>
                </Fade>
              );
            })}
          </div>

        </div>
      </section>
      <Discuss />
    </>
  );
}
